import {getMeasurementValue} from "./getMeasurementValue";

type FilterMeasurementsProps = {
  measurements: any[];
  selectedMetric: string;
  selectedGuestId: string;
};

export const filterMeasurements = ({
  measurements,
  selectedMetric,
  selectedGuestId,
}: FilterMeasurementsProps) => {
  return measurements
    .filter((measurement) => measurement.type === selectedMetric && measurement.lineId === selectedGuestId)
    .sort((a, b) => new Date(b.measureDateTime).getTime() - new Date(a.measureDateTime).getTime())
    .map((measurement) => ({
      id: measurement.id,
      dateTime: measurement.measureDateTime,
      value: getMeasurementValue(measurement),
      raw: measurement,
    }));
};
